<template>
<!-- v-on="$listeners" -->
  <b-dropdown
    variant="link"
    toggle-class="text-decoration-none p-0"
    no-caret
    class="dropdownFilter d-flex justify-content-center"
    right
    dropup
    :ref="'internalDropdownFilterSort' + localIndex"
    @hide="hideDialogFilter"
    @show="showDialogFilter"
    @shown="toggle(true)"
    @hidden="toggle(false)"
  >
    <template #button-content ref="icon_filter">
      <slot name="overlap_button_dialog"></slot>
    </template>
    <!-- Text filter sort component -->
    <text-filter-sort-modal
      :ref="'filterDialog' + localIndex"
      v-if="localTLabel.dataType === 0"
      :isItemNo="localTLabel.isItemNo"
      :defaultItemName="localTLabel.defaultItemName"
      @on-sort="handleSortOrder"
      :query-prameter-value="localQueryPrameterValue"
      @on-submit="onSubmit"
      @allow-edit-label="onEditLabelHeader"
      :disableChangeColumnName="disableChangeColumnName"
      :hideSortOrder="hideSortOrder"
    />
    <!-- Number filter sort component -->
    <number-filter-sort-modal
      :ref="'filterDialog' + localIndex"
      v-if="localTLabel.dataType === 1"
      :isItemNo="localTLabel.isItemNo"
      :defaultItemName="localTLabel.defaultItemName"
      @on-sort="handleSortOrder"
      :query-prameter-value="localQueryPrameterValue"
      @on-submit="onSubmit"
      @allow-edit-label="onEditLabelHeader"
      :disableChangeColumnName="disableChangeColumnName"
      :hideSortOrder="hideSortOrder"
    />
    <!-- Date filter sort component -->
    <date-filter-sort-modal
      :ref="'filterDialog' + localIndex"
      v-if="localTLabel.dataType === 3"
      :isItemNo="localTLabel.isItemNo"
      :defaultItemName="localTLabel.defaultItemName"
      @on-sort="handleSortOrder"
      @on-submit="onSubmit"
      :query-prameter-value="localQueryPrameterValue"
      @allow-edit-label="onEditLabelHeader"
      @open-datepicker="handleOpenDatePicker"
      @close-datepicker="handleCloseDatePicker"
      @onInput="handleOnInput"
      :disableChangeColumnName="disableChangeColumnName"
      :hideSortOrder="hideSortOrder"
    />
    <!-- List filter sort component -->
    <filterable-listbox
      :ref="'filterDialog' + localIndex"
      v-if="localTLabel.dataType === 2"
      :pOption="localTLabel.mstGenCode"
      :isItemNo="localTLabel.isItemNo"
      :defaultItemName="localTLabel.defaultItemName"
      @on-submit="onSubmitListFilter"
      :pListSelected="localQueryPrameterValue[localTLabel.isItemNo]"
      @on-sort="handleSortOrder"
      @allow-edit-label="onEditLabelHeader"
      :disableChangeColumnName="disableChangeColumnName"
      :hideSortOrder="hideSortOrder"
    />
  </b-dropdown>
</template>

<script>
import DateFilterSortModal from './DateFilterSortModal.vue'
import FilterableListbox from './FilterableListbox.vue'
import NumberFilterSortModal from './NumberFilterSortModal.vue'
import TextFilterSortModal from './TextFilterSortModal.vue'
export default {
  components: {
    TextFilterSortModal,
    NumberFilterSortModal,
    DateFilterSortModal,
    FilterableListbox
  },
  props: ['queryPrameterValue', 'index', 'sort', 'tLabel', 'disableChangeColumnName', 'hideSortOrder'],
  data() {
    return {
      localIndex: this.index,
      localQueryPrameterValue: this.queryPrameterValue,
      localSort: this.sort,
      localTLabel: this.tLabel,
      isShow: false,
      isDatePickerOpen: false,
      isDatePickerInput: false
    }
  },
  watch: {
    queryPrameterValue(newValue, oldValue) {
      this.localQueryPrameterValue = newValue
    },
    sort(newValue, oldValue) {
      this.localSort = newValue
    },
    tLabel(newValue, oldValue) {
      this.localTLabel = newValue
    }
  },
  methods: {
    /**
     * 非表示のドロップダウン イベントを処理する
     * @param {BvEvent} event ドロップダウンが非表示になる前にイベントを発行する
     */
    hideDialogFilter(event) {
      if (this.isDatePickerOpen && this.localTLabel.dataType === 3 && event) {
        event.preventDefault()
        this.isDatePickerOpen = this.$refs['filterDialog' + this.localIndex].isDatePickerOpen
        this.isDatePickerInput = false
        return
      }
      this.$refs['internalDropdownFilterSort' + this.localIndex].hide()
      this.$emit('isDisabledDragCol', false)
      this.$refs['filterDialog' + this.localIndex].resetValueComponent()
    },
    showDialogFilter() {
      this.$refs['internalDropdownFilterSort' + this.localIndex].show()
      this.$emit('isDisabledDragCol', true)
      this.$refs['filterDialog' + this.localIndex].initValueComponent(this.localSort, this.localTLabel.isItemNo)
    },
    toggle(check) {
      check ? this.isShow = true : this.isShow = false
    },
    onSubmitListFilter(queryParam) {
      this.$emit('onSubmit', queryParam, true)
      this.hideDialogFilter()
    },
    onSubmit(queryParam) {
      this.$emit('onSubmit', queryParam, false)
      this.hideDialogFilter()
    },
    handleSortOrder(data) {
      this.$emit('handleSortOrder', data)
      this.hideDialogFilter()
    },
    onEditLabelHeader() {
      this.$emit('allow-edit-label')
    },
    /**
     * カレンダーが開いているときにドロップダウンを開いたままにする
     */
    handleOpenDatePicker() {
      this.isDatePickerOpen = true
      this.isDatePickerInput = false
    },
    /**
     * カレンダーが閉じたらドロップダウンを閉じる
     * @param {boolean} isClose ドロップダウンを閉じる
     */
    handleCloseDatePicker(isClose) {
      if (this.isDatePickerInput) {
        return
      }
      this.isDatePickerOpen = isClose
    },
    /**
     * 値変更後の入力ハンドルイベント
     */
    handleOnInput() {
      this.isDatePickerInput = true
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/custom-components/FilterSortDropdown.vue